import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FaixaDescargaCIF } from 'src/app/models/faixa-descarga-cif';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FaixaDescargaCifService } from 'src/app/services/faixa-descarga-cif.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import swal from 'sweetalert2';
import { CadastrarFaixaDescargaCifModalComponent } from '../cadastrar-faixa-descarga-cif-modal/cadastrar-faixa-descarga-cif-modal.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-faixa-descarga-cif',
  templateUrl: './faixa-descarga-cif.component.html',
  styleUrls: ['./faixa-descarga-cif.component.scss']
})
export class FaixaDescargaCifComponent implements OnInit {
  faixas: FaixaDescargaCIF[];
  ultimaFaixa: FaixaDescargaCIF;
  campoOrdenacao = 'de';
  ordenarDesc = false;
  filtroDescricao = '';
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private dialog: MatDialog,
    private faixaDescargaCifService: FaixaDescargaCifService,
    private dialogRef: MatDialogRef<FaixaDescargaCifComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private paginatorService: PaginatorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFaixas();
    this.buscarUltimaFaixaCadastrada();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFaixas();
  }

  filtra() {
    this.buscarFaixas();
    this.paginator.firstPage();
  }

  buscarFaixas() {
    this.carregandoService.mostra('buscarFaixas');

    this.faixaDescargaCifService.consultarComPaginacao(
      this.filtroDescricao,
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
    )
      .subscribe(
        (dados) => {
          this.faixas = dados.itens;

          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.buscarUltimaFaixaCadastrada();

          this.carregandoService.esconde('buscarFaixas');
        },
        (erro) => {
          this.carregandoService.esconde('buscarFaixas');
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarUltimaFaixaCadastrada() {
    this.carregandoService.mostra('buscarFaixas');

    this.faixaDescargaCifService.consultarUltimaFaixa()
      .subscribe(
        (dados) => {
          this.ultimaFaixa = dados;

          this.carregandoService.esconde('buscarFaixas');
        },
        (erro) => {
          this.carregandoService.esconde('buscarFaixas');
          this.ultimaFaixa = new FaixaDescargaCIF();
          this.ultimaFaixa.de = 0;
          this.ultimaFaixa.ate = 0;
        }
      );
  }

  novaFaixa() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarFaixaDescargaCifModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: new FaixaDescargaCIF(), ultimaFaixa: this.ultimaFaixa, itens: this.faixas },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FaixaDescargaCIF) => {
      if (result) {
        this.validarSalvar(result);
      }
    });
  }

  editarFaixa(item: FaixaDescargaCIF) {
    const itemParaEditar = new FaixaDescargaCIF();

    Object.assign(itemParaEditar, item);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarFaixaDescargaCifModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: itemParaEditar, itens: this.faixas.filter(p => p !== item) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FaixaDescargaCIF) => {
      if (result) {
        this.validarSalvar(result);
      }
    });
  }

  validarSalvar(item: FaixaDescargaCIF) {
    if (Number(item.de) > Number(item.ate)) {
      swal({
        title: 'O valor inicial deve ser menor do que o desconto final!',
        text: '',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else if (this.faixas.some(p => (
      (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.de) && Number(item.ate) <= Number(p.ate)) ||
      (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.ate)) ||
      (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) <= Number(p.ate)) ||
      (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) >= Number(p.ate))))) {
      swal({
        title: 'Já existem valores dentro da mesma faixa de descarga!',
        text: 'Deseja substituí-los?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning'
      }).then((result) => {
        if (result.value) {
          const existentes = this.faixas.filter(p => (
            (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.de) && Number(item.ate) <= Number(p.ate)) ||
            (Number(item.de) <= Number(p.de) && Number(item.ate) >= Number(p.ate)) ||
            (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) <= Number(p.ate)) ||
            (Number(item.de) >= Number(p.de) && Number(item.de) <= Number(p.ate) && Number(item.ate) >= Number(p.ate))));

          existentes.forEach(p => {
            this.carregandoService.mostra('excluir');
            this.faixaDescargaCifService.excluir(p.id).subscribe(
              () => {
                this.carregandoService.esconde('excluir');
                this.salvar(item);
              },
              err => {
                this.carregandoService.esconde('excluir');
                this.notificacaoService.erro(err);
              }
            );
          });
        }
      });
    } else {
      this.salvar(item);
    }
  }

  salvar(item: FaixaDescargaCIF) {
    item.de = Number(item.de);
    item.ate = Number(item.ate);
    item.valor = Number(item.valor);

    this.carregandoService.mostra('salvar');
    this.faixaDescargaCifService.salvar(item).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Faixa adicionada com sucesso!!!');
        this.buscarFaixas();
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  excluirFaixa(item: FaixaDescargaCIF) {
    swal({
      title: 'Deseja realmente Excluir a Faixa ' + 'de ' + item.de.toFixed(2) + ' até ' + item.ate.toFixed(2) + ' ?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluir');
        this.faixaDescargaCifService.excluir(item.id).subscribe(
          () => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.sucesso('Faixa excluída com sucesso!!!');
            this.buscarFaixas();
          },
          err => {
            this.carregandoService.esconde('excluir');
            this.notificacaoService.erro(err);
          }
        );
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
